function InquiryCallbackStatusBadge ({ status }) {
  let color = 'secondary'

  if (
    status === 'SUCCESS' ||
        status === '00' ||
        String(status).startsWith('2')
  ) {
    color = 'success'
  } else if (
    status === 'FAIL' ||
        String(status).startsWith('4') ||
        String(status).startsWith('5')
  ) {
    color = 'danger'
  }

  return (
        <span className={`status-${color}`}>
            {status}
        </span>
  )
}

export default InquiryCallbackStatusBadge
